import { render, staticRenderFns } from "./cancel-premium.vue?vue&type=template&id=c176f222&scoped=true"
import script from "./cancel-premium.vue?vue&type=script&lang=js"
export * from "./cancel-premium.vue?vue&type=script&lang=js"
import style0 from "./cancel-premium.vue?vue&type=style&index=0&id=c176f222&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c176f222",
  null
  
)

export default component.exports